export interface EchoState {
  x: number;
  y: number;
  z: number;
  timestamp: number;
}

export class EchoRecorder {
  private path: EchoState[] = [];

  record(position: Omit<EchoState, "timestamp">) {
    this.path.push({ ...position, timestamp: Date.now() });
    if (this.path.length > 120) this.path.shift();
  }

  drain() {
    const copy = [...this.path];
    this.path = [];
    return copy;
  }
}
